import React, { useCallback } from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportRetentionsExistsFilters, getReportRetentionsExistsAction } from "redux/actions/Reports/reportRetentionsExists/reportRetentionsExistsActions";
import { useSearch } from "hooks/useSearch";

export const ReportRetentionsExistsView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportRetentionsExists);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault();
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportRetentionsExistsAction({ startDate, endDate, station, isPdf }));
  }, [startDate, endDate, station]);

  return (
    <GlobalBox title="Reporte Salidas de Retenciones" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportRetentionsExists"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportRetentionsExistsFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingRetentionsExists}
      />
      {isLoadingComp?.loadingRetentionsExists && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
